export default __webpack_public_path__ + "static/media/Rationsservice.100001c3.jpg";